import React from 'react';
import { styled } from 'components/Theme';
import { Button } from 'components';

interface Props {
  label?: string;
  className?: string;
  color?: 'primary' | 'secondary' | 'default';
  loading?: boolean;
  disabled?: boolean;
  multiple?: boolean;
  onUpload: (files: File[]) => void;
}

export const AttachFile: React.FC<Props> = ({
  label = 'Attach File',
  className,
  color = 'default',
  loading = false,
  disabled = false,
  multiple = false,
  onUpload
}) => {
  const fileInput = React.createRef<HTMLInputElement>();
  const uploadFile = () => {
    if (fileInput && fileInput.current) fileInput.current.click();
  };

  const handleChange = (ev: any) => {
    const files = Array.from(ev.target.files) as Array<File>;
    onUpload(files);
  };

  return (
    <AttachFileWrapper className={className}>
      <Button label={label} color={color} disabled={disabled} loading={loading} onClick={uploadFile} />
      <input
        className="file-holder"
        multiple={multiple}
        type="file"
        name="avatar"
        ref={fileInput}
        accept="image/png, image/jpeg, application/pdf"
        onChange={handleChange}
      />
    </AttachFileWrapper>
  );
};

const AttachFileWrapper = styled.div`
  .file-holder {
    display: none;
  }
`;
